import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const galleryImages = [
  { src: 'https://i.ibb.co/qLSPrnrZ/50745198-639219803197614-3241420949391671296-n.jpg', alt: 'Smoke Alarm Installation' },
  { src: 'https://i.ibb.co/Fkh2YyZh/50658301-639219823197612-1472516235919884288-n.jpg', alt: 'Fire Alarm Installation' },
  { src: 'https://i.ibb.co/Z1tYvfHz/50505583-634538576999070-6703315287485186048-n.jpg', alt: 'Electrical Installation Work' },
  { src: 'https://i.ibb.co/C3pNSMNL/50314711-634538543665740-3882336778417340416-n.jpg', alt: 'Consumer Unit Installation' },
  { src: 'https://i.ibb.co/WNKMmc9K/38763039-538696089916653-2169134921736519680-n.jpg', alt: 'Electrical Fault Finding' },
  { src: 'https://i.ibb.co/RkczfD3Z/38290551-531616050624657-4877571857286430720-n.jpg', alt: 'EV Charger Installation' },
  { src: 'https://i.ibb.co/rKjQy0Nm/38218462-531616473957948-8257493037979009024-n.jpg', alt: 'Smart Home Installation' },
  { src: 'https://i.ibb.co/gZxHHC5N/506796606-1214560377034530-4777178540819997255-n.jpg', alt: 'Electrical Installation' },
  { src: 'https://i.ibb.co/Vp20DgKB/497908311-1214557047034863-3364707288013603769-n.jpg', alt: 'Consumer Unit Upgrade' },
  { src: 'https://i.ibb.co/zHPGjKGW/480582835-2181606785625567-3057077296093305233-n.jpg', alt: 'Electrical Repairs' },
];

export default function Gallery() {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  return (
    <section id="gallery" className="py-16 sm:py-20 bg-gradient-to-b from-[#0D1F3C] to-[#0A1628] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Our <span className="text-[#FFD700]">Work Gallery</span>
          </h2>
          <p className="text-gray-400 text-sm sm:text-base max-w-xl mx-auto">
            A snapshot of our completed projects across Watford, Rickmansworth &amp; surrounding areas
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="group relative aspect-square overflow-hidden rounded-lg cursor-pointer bg-[#0D1F3C]"
              onClick={() => setSelectedImage(image.src)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                <i className="ri-zoom-in-line text-[#FFD700] text-xl"></i>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="mt-10 text-center">
          <button
            onClick={() => navigate('/gallery')}
            className="inline-flex items-center gap-2 bg-[#FFD700] text-[#0A1628] px-8 py-3.5 rounded-full font-bold text-base hover:bg-[#FFC700] transition-all duration-300 shadow-xl hover:shadow-[#FFD700]/40 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-image-line"></i>
            View Full Gallery
          </button>
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white text-4xl hover:text-[#FFD700] transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
            aria-label="Close"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={selectedImage}
            alt="Gallery Image"
            className="max-w-full max-h-full object-contain rounded-lg"
          />
        </div>
      )}
    </section>
  );
}